// Modalless Layer
NP.Modalless = (function( $ ) {
	var setCenter = NP.ns( 'Util.setCenter' ),
		stack = NP.ns( 'Util.stack' ),
		instance = 0;

	function Modalless() {
		this.ctx = [];
		this.isOn = !1;

		this.onBeforeShow = $.Callbacks();
		this.onShow = $.Callbacks();
		this.onHide = $.Callbacks();

		Modalless.evtBind.call( this );
	}

	Modalless.evtBind = function() {
		$('.js_modalless').on('click', function( e ) {
			e.preventDefault();

			var layer = $( this ).data('layer');
			if ( !layer ) return;

			instance.show( $( layer ) );
		});
	};

	Modalless.setCenter = function() {
		setCenter( instance.ctx );
	};

	Modalless.prototype.show = function( ctx, isNotCenter ) {
		if ( !ctx || !ctx.length ) return;

		this.onBeforeShow.fire( ctx );

		stack( this.ctx, ctx );

		ctx.css({
			display : 'none',
			right: 'auto',
			position : 'absolute'
		}).appendTo('body').show().find('.js_close').bind('click', function() {
			$( this ).unbind();
			instance.hide();
		});

		if( !isNotCenter ){ 
			setCenter( this.ctx );

			!this.isOn && $( window ).bind({
				resize : Modalless.setCenter
			});
		};

		this.onShow.fire();
		this.isOn = !0;
	};

	Modalless.prototype.hide = function() {
		var ctx = this.ctx.pop().hide();

		$( window ).unbind({
			resize : Modalless.setCenter
		});

		this.onHide.fire( ctx );
		this.isOn = !1;
	};

	return {
		getInstance : function() {
			if ( !instance ) {
				instance = new Modalless();
				instance.constructor = null;
			}
			return instance;
		}
	};
}( jQuery ));

var modalless = NP.Modalless.getInstance();
modalless.onShow.add(function() {
	mProfile.isOn && mProfile.hide();
});
modalless.onBeforeShow.add(function() {
	modalless.isOn && modalless.hide();
});
modalless.onBeforeShow.add( NP.zIndex['+'] );
modalless.onHide.add( NP.zIndex['-'] );
modalless.onHide.add(function() {
	NP.Like.resetLastNum();
	jQuery( '#modallessLikeList' ).remove();
});
